import React, { useId, useRef, useState } from 'react';
import { FiInfo } from 'react-icons/fi';

const InfoTooltip = ({
  message, label = 'Más información', className = '', children,
  triggerClassName, disabled = false, ariaDisabled = false,
}) => {
  const generatedId = useId();
  const tooltipId = `info-tooltip-${generatedId.replace(/:/g, '')}`;
  const pointerInteractionRef = useRef(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  if (!message) return null;

  const isOpen = isPinned || (!isDismissed && (isHovered || isFocused));

  const closeTooltip = () => {
    setIsPinned(false);
    setIsDismissed(true);
  };

  return (
    <span
      className={`relative inline-flex items-center ${className}`}
      onMouseEnter={() => {
        setIsHovered(true);
        setIsDismissed(false);
      }}
      onMouseLeave={() => setIsHovered(false)}
    >
      <button
        type="button"
        aria-label={label}
        aria-describedby={tooltipId}
        aria-expanded={isOpen}
        aria-controls={tooltipId}
        aria-disabled={ariaDisabled || undefined}
        disabled={disabled}
        title={message}
        className={triggerClassName || 'inline-flex h-5 w-5 items-center justify-center rounded-full text-gray-400 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:text-blue-600'}
        onPointerDown={() => {
          pointerInteractionRef.current = true;
        }}
        onClick={() => {
          const nextPinned = !isPinned;
          setIsPinned(nextPinned);
          setIsDismissed(!nextPinned);
          pointerInteractionRef.current = false;
        }}
        onFocus={() => {
          setIsFocused(true);
          if (!pointerInteractionRef.current) setIsDismissed(false);
        }}
        onBlur={() => {
          setIsFocused(false);
          setIsPinned(false);
          setIsDismissed(false);
          pointerInteractionRef.current = false;
        }}
        onKeyDown={(event) => {
          if (event.key !== 'Escape' || !isOpen) return;
          event.preventDefault();
          event.stopPropagation();
          closeTooltip();
        }}
      >
        {children ?? <FiInfo size={14} aria-hidden="true" />}
      </button>
      <span
        id={tooltipId}
        role="tooltip"
        className={`pointer-events-auto fixed bottom-24 left-4 right-4 z-[1900] rounded-md bg-gray-900 px-3 py-2 text-left text-[11px] font-normal leading-relaxed text-white shadow-lg lg:absolute lg:bottom-full lg:left-1/2 lg:right-auto lg:z-50 lg:mb-2 lg:w-64 lg:max-w-[calc(100vw-2rem)] lg:-translate-x-1/2 ${isOpen ? 'block' : 'hidden'}`}
      >
        {message}
      </span>
    </span>
  );
};

export default InfoTooltip;
